<template>
  <div v-if="hasDetails" class="rounded border bg-white overflow-hidden">
    <button
      type="button"
      class="w-100 d-flex align-items-center justify-content-between px-3 py-3 border-0 bg-white text-start"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
    >
      <span class="fs-7 fw-semibold text-gray-700">Подробности расчёта</span>
      <i
        class="ki-duotone ki-down fs-4 text-gray-600 transition"
        :class="{ 'rotate-180': expanded }"
      ></i>
    </button>
    <div v-show="expanded" class="border-top px-3 py-3">
      <premium-calculation-bpm-details
        :calculation="calculation"
        :policy="policy"
        :module="module"
      />
    </div>
  </div>
</template>

<script>
import PremiumCalculationBpmDetails from '@/components/Form/Bpm/Policy/PremiumCalculationBpmDetails.vue'

export default {
  name: 'PremiumCalculationBpmCollapse',
  components: {
    PremiumCalculationBpmDetails,
  },
  props: {
    calculation: {
      type: Object,
      default: null,
    },
    policy: {
      type: Object,
      required: true,
    },
    module: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    hasDetails() {
      const calc = this.module.PremiumCalculation
      return calc.getOgpoRows(this.calculation, this.policy).length > 0
        || calc.getDgpoRows(this.calculation, this.policy).length > 0
    },
  },
}
</script>

<style scoped>
.transition {
  transition: transform 0.2s ease;
}
.rotate-180 {
  transform: rotate(180deg);
}
</style>
